/* spring-highlight — subtle vertical parallax on the card's background image.
   The image is given a 20% vertical overscan in CSS (height 120%, top -10%);
   this translates it within that slack as the card scrolls through the
   viewport, so its edges never show. Disabled under reduced-motion. */
class SpringHighlight extends HTMLElement {
  connectedCallback() {
    this.media = this.querySelector('.spring-highlight__media');
    this.image = this.querySelector('.spring-highlight__image');
    if (!this.media || !this.image) return;

    // Skip on slow/save-data connections (theme.liquid flags <html.low-data>).
    if (document.documentElement.classList.contains('low-data')) return;

    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (this.reduceMotion.matches) return;

    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);
    this.update = this.update.bind(this);

    this.classList.add('spring-highlight--parallax');
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(this.update);
  }

  update() {
    this.ticking = false;
    const rect = this.media.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    if (rect.bottom < 0 || rect.top > vh) return; // off-screen, skip

    // 0 when the card is entering at the bottom, 1 when it has left the top.
    const progress = (vh - rect.top) / (vh + rect.height);
    const clamped = Math.max(0, Math.min(1, progress));
    const travel = rect.height * 0.28; // stay inside the 30%-each-way overscan
    const y = (clamped - 0.5) * 2 * travel; // -travel .. +travel
    this.image.style.setProperty('--hl-parallax-y', `${(-y).toFixed(2)}px`);
  }
}

if (!customElements.get('spring-highlight')) {
  customElements.define('spring-highlight', SpringHighlight);
}
